import { createRoot, hydrateRoot } from 'react-dom/client'
import './fonts.css'
import './index.css'
import App from './App.tsx'
import { matchRoute } from './routes'

// Pas de <StrictMode> : en dev il monte l'arbre, le démonte et le remonte, ce qui
// réinitialise les 5 canvas de /gradient-descent et donne un net double chargement
// à l'écran. Comportement dev uniquement — la production n'a jamais été affectée.
// En contrepartie on perd le détecteur d'effets mal nettoyés : le réactiver le temps
// d'un debug (réenvelopper <App /> ci-dessous) reste la bonne réaction si un
// composant se met à fuir un listener, un timer ou un contexte WebGL.

const container = document.getElementById('root')!

// La page de la route courante est chargée AVANT le montage. Sans ça, React.lazy
// suspendrait au premier rendu : à l'hydratation il jetterait tout le HTML
// prérendu pour afficher le fallback, ce qui annulerait le bénéfice du prerender
// et provoquerait un flash. Une fois le module résolu, on le passe en `preloaded`
// pour que le premier rendu client soit identique au HTML du serveur.
const route = matchRoute(window.location.pathname)

route
  .load()
  .then(({ default: Component }) => {
    const app = <App preloaded={{ path: route.path, Component }} />
    // Le dev server ne prérend pas : #root y est vide, il faut createRoot.
    if (container.hasChildNodes()) {
      hydrateRoot(container, app, {
        // Sans ce hook, un échec d'hydratation est INVISIBLE : React 19 le route
        // vers window.reportError (pas console.error), jette le DOM prérendu et
        // re-rend tout côté client — à l'écran, la page « se recharge ». On trace
        // pour que ça ne puisse plus passer inaperçu.
        onRecoverableError(error, errorInfo) {
          interface Traced { __hydrationErrors?: unknown[] }
          ;((window as unknown as Traced).__hydrationErrors ??= []).push(error)
          console.warn('[hydration] erreur récupérable :', error, errorInfo?.componentStack)
        },
      })
    } else {
      createRoot(container).render(app)
    }
  })
  .catch(() => {
    // Si le chunk de la route ne charge pas, on monte quand même la coquille :
    // navbar et routage restent utilisables, le lazy retentera au rendu.
    createRoot(container).render(<App />)
  })
